module.exports = __webpack_public_path__ + "../resources/img/pictogram_grid.563a3550.png";